import { useMemo, useState } from 'react';

export interface BoolControl {
  enabled: boolean;
  set(enabled: boolean): void;
  enable(): void;
  disable(): void;
  toggle(): void;
}

// a simple 'useState' wrapper that provides direct
// modifier methods to be used as callbacks
export function useBool(initialValue: boolean): BoolControl {
  const [value, set] = useState(initialValue);

  function enable() {
    set(true);
  }
  function disable() {
    set(false);
  }
  function toggle() {
    set(!value);
  }

  const obj = useMemo<BoolControl>(
    () => ({
      enabled: value,
      set,
      enable,
      disable,
      toggle,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value],
  );

  return obj;
}
